import {
  deviceFieldSnapshotForQuoteItem,
  requireDeviceSku,
} from '../state/deviceCatalog';
import { createPricingBaseSnapshot, quoteSubtotal } from '../state/quoteTotals';
import type {
  BusinessCatalog,
  DeviceCatalogRecord,
  QuoteItem,
  QuoteSelectionDevice,
  QuoteSourceSnapshot,
} from '../state/types';

export function requireCatalogDevice(
  catalog: BusinessCatalog,
  deviceId: string,
): DeviceCatalogRecord {
  const device = catalog.devices.find((item) => item.id === deviceId);
  if (!device) throw new Error(`设备 ${deviceId} 不存在`);
  return device;
}

export function catalogDeviceStock(device: QuoteSelectionDevice): number {
  return Object.values(device.stockByWarehouse).reduce(
    (total, quantity) => total + quantity,
    0,
  );
}

export function createCatalogQuoteItem(
  device: DeviceCatalogRecord,
  options: Pick<QuoteItem, 'itemId'> & QuoteSourceSnapshot,
): QuoteItem {
  const pricingBaseSnapshot = createPricingBaseSnapshot('rental', {
    rentalPrice: device.rentalPrice,
  });
  return {
    ...options,
    deviceId: device.id,
    name: device.name,
    sku: requireDeviceSku(device),
    quantity: 1,
    unitPrice: pricingBaseSnapshot.amount,
    discount: 100,
    pricingBaseSnapshot,
    deviceFieldSnapshot: deviceFieldSnapshotForQuoteItem(device),
    stock: catalogDeviceStock(device),
  };
}

export function quoteItemsTotal(items: QuoteItem[]): number {
  return quoteSubtotal(items);
}
